import {
    Button,
    Card,
    CardContent,
    Grid,
    Tooltip,
} from '@mui/material';
import CustomisedUploadFile from '../uploader/uploadFile';
import { IUploadFile } from '../uploader/IUploadFile';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ExtendedFile, ICardUpload } from './ICardUpload';
import { useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { toast } from "react-toastify";

export default function CustomisedCardMultiUpload({
    title,
    comment,
    setFileSelected,
    fileExtensions,
    setAddSuccess,
    maxSizeKb
}: ICardUpload) {
    async function handleOnFileChoosed(files: ExtendedFile[]) {
        files.map(async (item: any) => {
            if ((item.size / 1024) > maxSizeKb!) {
                toast.error("فایل سایز عکس مورد نظر بیشتر از اندازه مجاز است.");
                return;
            } else {
                const fileUrlObj = {
                    file: files[0],
                    fileUrl: files[0].preview,
                    fileName: files[0].name,
                    title: title,
                };
                if (files[0].preview !== undefined) {
                    setFileSelected(fileUrlObj);
                }
                setActiveButton(true);
                setAddImage(false);
                setAddSuccess(fileUrlObj);
                return;
            }
        })

    }
    const [openTooltip, setOpenTooltipValue] = useState(null);
    const [activeButton, setActiveButton] = useState(false);
    const [addImage, setAddImage] = useState(false);
    const toggleClick = (index: any) => {
        setOpenTooltipValue(openTooltip === index ? null : index);
    };
    const clickAddImage = () => {
        setAddImage(true);
    }
    return (
        <Grid container style={{ alignItems: 'center' }}>
            <Grid item xs={12} style={{
                paddingBottom: '20px', height: '24vh', minHeight: '20px',
                maxHeight: '229px', paddingTop: '20px',
                //  paddingRight: '3vw',
                // paddingLeft: '3vw'
            }} >
                <CustomisedUploadFile
                    onFileChoosed={handleOnFileChoosed}
                    fileExtensions={fileExtensions}
                    maxSizeKb={maxSizeKb}
                />
            </Grid>

        </Grid>
    );
}
